.canvas {
	position: absolute;
	inset: 0;
	display: block;
	width: 100%;
	height: 100%;
	touch-action: manipulation;
	cursor: pointer;
}

.error {
	display: grid;
	height: 100%;
	place-items: center;
	padding: 24px;
	color: #e04f67;
	background: #fff5f6;
	text-align: center;
}
